// re-export only used glyphs in order to three-shake unused ones
export { Ai } from '@sunwebgroup/uds-icons'
export { AirplaneTakingOff } from '@sunwebgroup/uds-icons'
export { AirplaneToRight } from '@sunwebgroup/uds-icons'
export { AirplaneToRightTop } from '@sunwebgroup/uds-icons'
export { AirplaneToTop } from '@sunwebgroup/uds-icons'
export { AirplaneWithArrowsCirclePath } from '@sunwebgroup/uds-icons'
export { AppartmentBuilding } from '@sunwebgroup/uds-icons'
export { ArrowDownInCircleMulticolor } from '@sunwebgroup/uds-icons'
export { ArrowUpFromLine } from '@sunwebgroup/uds-icons'
export { ArrowsCirclePath } from '@sunwebgroup/uds-icons'
export { ArrowsSquarePath } from '@sunwebgroup/uds-icons'
export { Baby } from '@sunwebgroup/uds-icons'
export { Bed } from '@sunwebgroup/uds-icons'
export { Bell } from '@sunwebgroup/uds-icons'
export { Bike } from '@sunwebgroup/uds-icons'
export { BowlWithFood } from '@sunwebgroup/uds-icons'
export { BusFront } from '@sunwebgroup/uds-icons'
export { BusRight } from '@sunwebgroup/uds-icons'
export { BusLeft } from '@sunwebgroup/uds-icons'
export { Cake } from '@sunwebgroup/uds-icons'
export { Calendar } from '@sunwebgroup/uds-icons'
export { CarDoor } from '@sunwebgroup/uds-icons'
export { CarRight } from '@sunwebgroup/uds-icons'
export { CheckMark } from '@sunwebgroup/uds-icons'
export { CheckMarkExtraSmall } from '@sunwebgroup/uds-icons'
export { CheckMarkInCircle } from '@sunwebgroup/uds-icons'
export { CheckMarkSmall } from '@sunwebgroup/uds-icons'
export { ChevronDoubleSmall } from '@sunwebgroup/uds-icons'
export { ChevronDown } from '@sunwebgroup/uds-icons'
export { ChevronDownExtraSmall } from '@sunwebgroup/uds-icons'
export { ChevronLeft } from '@sunwebgroup/uds-icons'
export { ChevronLeftSmall } from '@sunwebgroup/uds-icons'
export { ChevronLeftExtraSmall } from '@sunwebgroup/uds-icons'
export { ChevronRight } from '@sunwebgroup/uds-icons'
export { ChevronRightSmall } from '@sunwebgroup/uds-icons'
export { ChevronRightExtraSmall } from '@sunwebgroup/uds-icons'
export { ChevronUp } from '@sunwebgroup/uds-icons'
export { ChevronUpExtraSmall } from '@sunwebgroup/uds-icons'
export { Clock } from '@sunwebgroup/uds-icons'
export { ClockMulticolor } from '@sunwebgroup/uds-icons'
export { Dismiss } from '@sunwebgroup/uds-icons'
export { DismissExtraSmall } from '@sunwebgroup/uds-icons'
export { DismissSmall } from '@sunwebgroup/uds-icons'
export { DocumentPdf } from '@sunwebgroup/uds-icons'
export { DocumentWithText } from '@sunwebgroup/uds-icons'
export { Duration } from '@sunwebgroup/uds-icons'
export { EllipsisHorizontal } from '@sunwebgroup/uds-icons'
export { Esim } from '@sunwebgroup/uds-icons'
export { ExclamationInCircle } from '@sunwebgroup/uds-icons'
export { ExclamationInTriangle } from '@sunwebgroup/uds-icons'
export { EighteenPlus } from '@sunwebgroup/uds-icons'
export { Eye } from '@sunwebgroup/uds-icons'
export { EyeSlashed } from '@sunwebgroup/uds-icons'
export { FaceHappy } from '@sunwebgroup/uds-icons'
export { FaceSad } from '@sunwebgroup/uds-icons'
export { Family } from '@sunwebgroup/uds-icons'
export { ForkAndKnive } from '@sunwebgroup/uds-icons'
export { GolfClub } from '@sunwebgroup/uds-icons'
export { Heart } from '@sunwebgroup/uds-icons'
export { HeartFilled } from '@sunwebgroup/uds-icons'
export { HeartWithSmallerHeart } from '@sunwebgroup/uds-icons'
export { House } from '@sunwebgroup/uds-icons'
export { Houses } from '@sunwebgroup/uds-icons'
export { ImageSlashed } from '@sunwebgroup/uds-icons'
export { InformationInCircle } from '@sunwebgroup/uds-icons'
export { LanguageTranslate } from '@sunwebgroup/uds-icons'
export { Leaf } from '@sunwebgroup/uds-icons'
export { List } from '@sunwebgroup/uds-icons'
export { LogoElizaWasHere } from '@sunwebgroup/uds-icons'
export { LogoSunweb } from '@sunwebgroup/uds-icons'
export { LogoPrimavera } from '@sunwebgroup/uds-icons'
export { LogoTiktok } from '@sunwebgroup/uds-icons'
export { LogoTotally } from '@sunwebgroup/uds-icons'
export { LogoFacebook } from '@sunwebgroup/uds-icons'
export { LogoInstagram } from '@sunwebgroup/uds-icons'
export { LogoYoutube } from '@sunwebgroup/uds-icons'
export { Lotus } from '@sunwebgroup/uds-icons'
export { Magnifier } from '@sunwebgroup/uds-icons'
export { ManualTransmission } from '@sunwebgroup/uds-icons'
export { Map } from '@sunwebgroup/uds-icons'
export { MapPin } from '@sunwebgroup/uds-icons'
export { MapPinOnMap } from '@sunwebgroup/uds-icons'
export { Minus } from '@sunwebgroup/uds-icons'
export { MinusExtraSmall } from '@sunwebgroup/uds-icons'
export { ParkingSign } from '@sunwebgroup/uds-icons'
export { PaymentCardWithCoins } from '@sunwebgroup/uds-icons'
export { Pencil } from '@sunwebgroup/uds-icons'
export { PercentageInCircleMulticolor } from '@sunwebgroup/uds-icons'
export { Person } from '@sunwebgroup/uds-icons'
export { PersonInCircle } from '@sunwebgroup/uds-icons'
export { PersonRunning } from '@sunwebgroup/uds-icons'
export { PersonSkiing } from '@sunwebgroup/uds-icons'
export { PersonWithSuitcase } from '@sunwebgroup/uds-icons'
export { PigBank } from '@sunwebgroup/uds-icons'
export { Placeholder } from '@sunwebgroup/uds-icons'
export { Plus } from '@sunwebgroup/uds-icons'
export { PlusExtraSmall } from '@sunwebgroup/uds-icons'
export { QuestionMarkInCircle } from '@sunwebgroup/uds-icons'
export { ShieldWithDismiss } from '@sunwebgroup/uds-icons'
export { ShieldWithLock } from '@sunwebgroup/uds-icons'
export { ShieldWithPlus } from '@sunwebgroup/uds-icons'
export { SkiPass } from '@sunwebgroup/uds-icons'
export { Skis } from '@sunwebgroup/uds-icons'
export { Sliders } from '@sunwebgroup/uds-icons'
export { SmallHouse } from '@sunwebgroup/uds-icons'
export { Snowflake } from '@sunwebgroup/uds-icons'
export { SpadeSymbol } from '@sunwebgroup/uds-icons'
export { Spinner } from '@sunwebgroup/uds-icons'
export { StarFilled } from '@sunwebgroup/uds-icons'
export { StarHalfFilled } from '@sunwebgroup/uds-icons'
export { Suitcase } from '@sunwebgroup/uds-icons'
export { SuitcaseOnWheels } from '@sunwebgroup/uds-icons'
export { SuitcaseOnWheelsWithCheckMark } from '@sunwebgroup/uds-icons'
export { Sweater } from '@sunwebgroup/uds-icons'
export { Tag } from '@sunwebgroup/uds-icons'
export { ThreePeople } from '@sunwebgroup/uds-icons'
export { Ticket } from '@sunwebgroup/uds-icons'
export { TicketFlight } from '@sunwebgroup/uds-icons'
export { TicketWithPercentage } from '@sunwebgroup/uds-icons'
export { TipiTent } from '@sunwebgroup/uds-icons'
export { TrashCan } from '@sunwebgroup/uds-icons'
export { TShirt } from '@sunwebgroup/uds-icons'
export { TwoChildren } from '@sunwebgroup/uds-icons'
export { TwoPeople } from '@sunwebgroup/uds-icons'
export { Villa } from '@sunwebgroup/uds-icons'
export { World } from '@sunwebgroup/uds-icons'
export { Cocktail } from '@sunwebgroup/uds-icons'
export { Dumbbell } from '@sunwebgroup/uds-icons'
export { Hamam } from '@sunwebgroup/uds-icons'
export { WiFi } from '@sunwebgroup/uds-icons'
export { SwimmingPool } from '@sunwebgroup/uds-icons'
export { LockClosed } from '@sunwebgroup/uds-icons'
export { ElevatorFilledWithPeople } from '@sunwebgroup/uds-icons'
export { Towel } from '@sunwebgroup/uds-icons'
export { PersonInWheelchair } from '@sunwebgroup/uds-icons'
export { PersonAtReception } from '@sunwebgroup/uds-icons'
export { ServingFoodWithCloche } from '@sunwebgroup/uds-icons'
export { ServingFoodWithClocheSlashed } from '@sunwebgroup/uds-icons'
export { ServingFoodWithStarCloche } from '@sunwebgroup/uds-icons'
export { ServingFoodWithPlusCloche } from '@sunwebgroup/uds-icons'
export { ServingFoodWithHalfCloche } from '@sunwebgroup/uds-icons'
export { ServingFoodWithFullCloche } from '@sunwebgroup/uds-icons'
export { HouseHeating } from '@sunwebgroup/uds-icons'
export { TvScreen } from '@sunwebgroup/uds-icons'
export { WashingMachine } from '@sunwebgroup/uds-icons'
export { WaterSlide } from '@sunwebgroup/uds-icons'
export { TennisBall } from '@sunwebgroup/uds-icons'
export { Clown } from '@sunwebgroup/uds-icons'
export { BabyAndWaterWaves } from '@sunwebgroup/uds-icons'
export { ToyHorseWithRoof } from '@sunwebgroup/uds-icons'
export { ChildSeatHighChair } from '@sunwebgroup/uds-icons'
export { BedSheets } from '@sunwebgroup/uds-icons'
export { LogoPinterest } from '@sunwebgroup/uds-icons'
export { NoImage } from '@sunwebgroup/uds-icons'
export { CrossMedium } from '@sunwebgroup/uds-icons'
export { Diamond } from '@sunwebgroup/uds-icons'
export { MountainsSlope } from '@sunwebgroup/uds-icons'
export { PlayFilled } from '@sunwebgroup/uds-icons'
export { Grid } from '@sunwebgroup/uds-icons'
export { CarFront } from '@sunwebgroup/uds-icons'
export { ThumbsUp } from '@sunwebgroup/uds-icons'
export { OptionalFacilities } from '@sunwebgroup/uds-icons' // TODO copied from old svgs, might need revision
export { Deposit } from '@sunwebgroup/uds-icons' // TODO copied from old svgs, might need revision
export { LuggageCheck } from '@sunwebgroup/uds-icons' // TODO copied from old svgs, might need revision
export { AirplaneReturn } from '@sunwebgroup/uds-icons' // TODO copied from old svgs, might need revision
export { Checklist } from '@sunwebgroup/uds-icons'
export { Group } from '@sunwebgroup/uds-icons'
export { Wallet } from '@sunwebgroup/uds-icons'
export { BeachUmbrella } from '@sunwebgroup/uds-icons'
export { BackpackWithCheckMark } from '@sunwebgroup/uds-icons'
export { SteeringWheel } from '@sunwebgroup/uds-icons'
export { PlusInSquare } from '@sunwebgroup/uds-icons'
export { PaymentCard } from '@sunwebgroup/uds-icons'
export { Spray } from '@sunwebgroup/uds-icons'
export { HouseWithHeart } from '@sunwebgroup/uds-icons'
export { BedFor2Persons } from '@sunwebgroup/uds-icons'
export { Child } from '@sunwebgroup/uds-icons'
export { HouseBadgePlus } from '@sunwebgroup/uds-icons'
export { ArrowUpInCircle } from '@sunwebgroup/uds-icons'
export { SquareArrowUp } from '@sunwebgroup/uds-icons'
export { SquareOnSquare } from '@sunwebgroup/uds-icons'
export { PersonStretching } from '@sunwebgroup/uds-icons'
export { DocumentWithEuro } from '@sunwebgroup/uds-icons'
export { OneWaySign } from '@sunwebgroup/uds-icons'
export { Envelope } from '@sunwebgroup/uds-icons'
export { Play } from '@sunwebgroup/uds-icons'
export { Image } from '@sunwebgroup/uds-icons'
export { Sun } from '@sunwebgroup/uds-icons'
export { PaymentCardSlashed } from '@sunwebgroup/uds-icons'
export { EuroCoinInSlot } from '@sunwebgroup/uds-icons'
export { AutomaticTransmission } from '@sunwebgroup/uds-icons'
export { DocumentWithArrowDownToLine } from '@sunwebgroup/uds-icons'
export { Mountains } from '@sunwebgroup/uds-icons'
export { MountainsWithArrowUp } from '@sunwebgroup/uds-icons'
export { PersonCrossCountrySkiing } from '@sunwebgroup/uds-icons'
export { MountainsGlacier } from '@sunwebgroup/uds-icons'
export { PersonOnSnowboardInRamp } from '@sunwebgroup/uds-icons'
export { SkiLiftCabin } from '@sunwebgroup/uds-icons'
export { SkiLiftChairSide } from '@sunwebgroup/uds-icons'
export { SkiLiftDrag } from '@sunwebgroup/uds-icons'
export { DismissInCircle } from '@sunwebgroup/uds-icons'
